<!--
 * @Author: zhonghao
 * @Date: 2023-07-06 19:40:18
-->
<template>
  <div class="bind-phone">
    <div class="txt1">设置登录密码</div>
    <div class="txt2">请完成以下内容设置</div>
    <!-- <div class="div-input">
      <input type="text" placeholder="请输入手机号" v-model="mobile" class="input-txt">
    </div> -->
    <!-- <div class="div-input">
      <input type="text" placeholder="请输入验证码" v-model="mobileCode" class="input-txt">
      <div class="get-code" v-if="!isclick" @click="handleGetCode">获取验证码</div>
      <van-count-down class="get-code" :time="time" format="ss" @finish="handleFinish" v-else />
    </div> -->
    <div class="div-input">
      <input type="password" placeholder="请输入登录密码" v-model="password" class="input-txt">
    </div>
    <div class="div-input">
      <input type="password" placeholder="请再次确认密码" v-model="confrimPassword" class="input-txt">
    </div>
    <div class="submit-btn" @click="handleSubmit" :class="isForm ? 'cur' : ''">完成</div>
  </div>
</template>

<script>
import { getCodeByMobile, bindMobile } from '@/api/bind'
import { Toast } from 'vant'
export default {
  name: 'bindPhone',
  data () {
    return {
      mobile: '',
      time: 60 * 1000,
      isclick: false,
      mobileCode: '', // 验证码
      password: '',
      confrimPassword: ''
    }
  },

  computed: {
    isForm () {
      return this.password && this.confrimPassword
    },
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    }
  },

  mounted () {
    this.mobile = this.userInfo.mobile
  },

  methods: {
    handleGetCode () {
      if (!this.mobile) {
        Toast('请输入手机号')
        return
      }
      let params = {
        mobile: this.mobile
      }
      this.isclick = true
      getCodeByMobile(params).then(res => {
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
    handleFinish () {
      this.isclick = false
    },
    handleSubmit () {
      if (!this.mobile) {
        Toast('请输入手机号')
        return
      }
      if (!this.mobileCode) {
        Toast('请输入验证码')
        return
      }
      if (!this.checked) {
        Toast('请先同意用户协议、隐私申明')
        return
      }
      let params = {
        mobile: this.mobile,
        code: this.mobileCode,
        inv_code: this.code,
      }
      bindMobile(params).then(res => {
        this.isBindPhone = true
        Toast(res.msg)
        if (res.code === 1) {
          setTimeout(() => {
            this.$router.back()
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.bind-phone {
  background-color: #1E2020;
  width: 100vw;
  min-height: 100vh;
  padding: 30px 20px;
  box-sizing: border-box;

  .txt1 {
    font-size: 24px;
    color: #FFFFFF;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 16px;
  }

  .txt2 {
    font-size: 12px;
    color: #F0E1C0;
    line-height: 12px;
    margin-bottom: 10px;
  }

  .div-input {
    line-height: 60px;
    display: flex;
    border-bottom: 1px solid #666666;
    align-items: center;

    &.code {
      display: block;
      padding-top: 30px;
      padding-bottom: 20px;
      box-sizing: border-box;

      .code-txt {
        display: flex;
        align-items: center;
        line-height: 16px;

        .code1 {
          font-size: 16px;
          width: 72px;
          color: #FFFFFF;

          .code-input {
            background-color: transparent;
            outline: none;
            border: none;
            width: 72px;
          }
        }

        .code2 {
          font-size: 16px;
          color: #999999;
        }
      }

      .code3 {
        font-size: 12px;
        color: #FFFFFF;
        line-height: 12px;
        margin-top: 10px;
      }
    }

    .input-txt {
      font-size: 16px;
      outline: none;
      border: none;
      background-color: transparent;
      flex: 1;
      color: #fff;

      &::placeholder {
        font-size: #999999;
      }
    }

    .get-code {
      color: #504632;
      font-size: 14px;
      text-align: center;
      line-height: 38px;
      font-weight: 500;
      width: 102px;
      border-radius: 100px;
      background-color: #F0E1C0;
      height: 38px;
    }
  }

  /deep/ .van-checkbox {
    margin-top: 20px;

    .van-checkbox__icon,
    .van-icon {
      width: 16px;
      height: 16px;
      color: #181919;
      line-height: normal;

      &::before {
        width: 16px;
        height: 16px;
        display: block;
        line-height: normal;
      }
    }

    .van-checkbox__label {
      display: flex;
      color: #626366;
      font-size: 12px;

      .xieyi {
        color: #fff;
      }
    }
  }

  .submit-btn {
    margin-top: 18PX;
    width: 100%;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background-color: #6C685E;
    border-radius: 100px;
    font-size: 16px;
    color: #504632;
    font-weight: 600;

    &.cur {
      background-color: #F0E1C0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/setPassword.vue